/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-04-22 10:52:15
 * @LastAuthor: xiaoyao
 * @lastTime: 2021-07-01 17:03:36
 */
import { asyncRouterMap, constantRouterMap } from '@/config/router.config'
import _ from 'lodash'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i])
      if (flag) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id)
  } else {
    return true
  }
}

function filterAsyncRouter(routerMap, perm_list) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(perm_list, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, perm_list)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { perm_list } = data
        const as = _.cloneDeep(asyncRouterMap)  //深拷贝保证不改变原数组，否则切换组织时，无法获取正确的路由
        const accessedRouters = filterAsyncRouter(as, perm_list)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js